import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { scoreColor } from '../shared/scoreColor'

const SIZE = 140
const STROKE = 10

const useStyles = makeStyles(() => ({
  root: {
    width: `${SIZE}px`,
    height: `${SIZE}px`,
    position: 'relative',
    flexShrink: 0
  },
  text: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
  },
  big: {
    fontSize: '32px',
    fontWeight: 700,
    color: 'var(--color-ai-700, #5b21b6)',
    lineHeight: 1
  },
  label: {
    fontSize: '10px',
    fontWeight: 700,
    color: 'var(--color-neutral-500)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginTop: 4
  },
  progressArc: {
    transition: 'stroke-dasharray 600ms ease'
  }
}))

function ScoreRing ({ value }) {
  const classes = useStyles()
  const pct = Math.max(0, Math.min(1, value || 0)) * 100
  const radius = (SIZE - STROKE) / 2
  const circumference = 2 * Math.PI * radius
  const dash = (pct / 100) * circumference

  return (
    <div className={classes.root}>
      <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={radius}
          stroke='var(--color-neutral-200)'
          strokeWidth={STROKE}
          fill='none'
        />
        <circle
          className={classes.progressArc}
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={radius}
          stroke={scoreColor(pct)}
          strokeWidth={STROKE}
          strokeLinecap='round'
          fill='none'
          strokeDasharray={`${dash} ${circumference}`}
          transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
        />
      </svg>
      <div className={classes.text}>
        <span className={classes.big}>{pct.toFixed(0)}%</span>
        <span className={classes.label}>weighted</span>
      </div>
    </div>
  )
}

ScoreRing.propTypes = {
  value: PropTypes.number
}

export default ScoreRing
